module.exports = __webpack_public_path__ + "static/media/malware.b7cf8e42.png";